<div class="wrapper">
  <div class="d-flex flex-row gap-sm-3 align-items-center mb-4 header">
    <svg-icon class="fill" src="assets/images/lootboxes/loot-box.svg" alt="Loot Box" srcset="" />
    <h2 class="font-30 fw-bold mb-0 title-text" translate>lootboxes</h2>
  </div>
  <div>
    <tabset class="lootboxes-tabs" type="pills">
      <tab [id]="lootBoxesTabs.PLAY" (selectTab)="changeTab($event)" [active]="isPlayTabActive">
        <ng-template tabHeading>
          <div class="tab-title d-flex gap-sm-1 align-items-center">
            <svg-icon src="assets/images/lootboxes/play-star-active.svg" alt="star" srcset="" />{{"play" | translate |
            titlecase}}
          </div>
        </ng-template>
        <div class="play-tab-body d-flex flex-column gap-sm-4 mt-4">
          <div class="container">
            <div class="row gap-sm-3">
              <input type="text" class="w-100 search-nft col" aria-label="Search in docs" name="search"
                [placeholder]="('search_lootbox_placeholder' | translate) + '...'" [formControl]="searchLootbox"
                (keyup)="onEnter($event)" (keypress)="restrictWhitespace($event)"
                (change)="restrictWhitespace($event)" />
              <div class="col-md-auto btn-group nft-filter" dropdown>
                <div dropdownToggle type="button" class="nft-filter-dropdown d-flex align-items-center gap-sm-1">
                  <span class="filter-title">{{"sort_by" | translate}}:</span>
                  <span>{{
                    (filterConfig.sortBy === SORT_ENUM.ASC
                    ? "price_low"
                    : "price_high"
                    ) | translate
                    }}
                  </span>
                  <svg-icon src="./assets/images/svg-icons/dropdown-arrow-down.svg"></svg-icon>
                </div>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                  <li class="m-2 cursor-pointer" role="menuitem"
                    [ngClass]="{ active: filterConfig.sortBy === SORT_ENUM.ASC}" (click)="sortLootboxes(SORT_ENUM.ASC)">
                    <span translate>price_low</span>
                  </li>
                  <li class="m-2 cursor-pointer" role="menuitem" [ariaSelected]="true"
                    (click)="sortLootboxes(SORT_ENUM.DESC)"
                    [ngClass]="{ active: filterConfig.sortBy === SORT_ENUM.DESC }">
                    <span translate>price_high</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- HIDING CONTENT WHEN LOADING FLAG IS TRUE -->
          <ng-container *ngIf="!fetchingLootboxes; else lootboxLoader">
            <div class="nft-list" *ngIf="lootboxList?.length; else emptyState">
              <app-prize-card *ngFor="let gameCard of lootboxList" [gameCard]="gameCard"
                (onAction)="onCardAction($event, gameCard)"></app-prize-card>
            </div>
            <!-- EMPTY STATE -> WITH AND WITHOUT SEARCH -->
            <ng-template #emptyState>
              <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-sm-4">
                <!-- <img [src]="!!searchLootbox.value ? 'assets/images/svg-icons/meme-1.svg' :'assets/images/error-man.png'"
                  alt="" srcset="" /> -->
                <div class="error-msg title-text d-flex flex-column align-items-center justify-content-center">
                  <h3 class="text-center">{{(!!searchLootbox.value ?"no_results_title" :
                    "no_lootboxes") | translate }}</h3>
                  <span class="text-center" translate>{{!!searchLootbox.value ? "no_results_info"
                    :"come_later_for_lootboxes"}}</span>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #lootboxLoader>
            <div class="loader-state d-flex flex-column align-items-center justify-content-center gap-sm-4">
              <app-loader [isLoading]="fetchingLootboxes" class="d-flex flex-row justify-content-center w-100"
                [loaderConfig]="{ height: 64, thickness: 4, isDarkBg:true }"></app-loader>
            </div>
          </ng-template>
        </div>
      </tab>
      <tab [id]="lootBoxesTabs.MY_PRIZES" (selectTab)="changeTab($event)" [active]="!isPlayTabActive">
        <ng-template tabHeading>
          <div class="tab-title d-flex gap-sm-1 align-items-center">
            <svg-icon src="assets/images/lootboxes/prizes-tab-active.svg" alt="nft" srcset="" translate />{{"prizes" |
            translate}}
          </div>
        </ng-template>
        <div class="d-flex flex-column gap-sm-4 mt-4 my-nft-body">
          <div class="container">
            <!-- <div class="row gap-sm-3" *ngIf="false">
              <input type="text" class="w-100 search-nft col" aria-label="Search in docs" name="search"
                [placeholder]="('search_nft_placeholder' | translate) + '...'" />
              <div class="col-md-auto btn-group nft-filter" dropdown>
                <div dropdownToggle type="button" class="nft-filter-dropdown d-flex align-items-center gap-sm-1">
                  <span class="filter-title" translate>sort_by:</span>
                  <span>{{
                    (filterConfig.sortBy === "PRICE_LOW"
                    ? "price_low"
                    : "price_high"
                    ) | translate
                    }}
                  </span>
                  <svg-icon src="./assets/images/svg-icons/dropdown-arrow-down.svg"></svg-icon>
                </div>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                  <li class="m-2 cursor-pointer" role="menuitem"
                    [ngClass]="{ active: filterConfig.sortBy === SORT_ENUM.PRICE_LOW}"
                    (click)="filterConfig.sortBy = SORT_ENUM.PRICE_LOW">
                    <span translate>price_low</span>
                  </li>
                  <li class="m-2 cursor-pointer" role="menuitem" [ariaSelected]="true"
                    (click)="filterConfig.sortBy = SORT_ENUM.PRICE_HIGH"
                    [ngClass]="{ active: filterConfig.sortBy === SORT_ENUM.PRICE_HIGH }">
                    <span translate>price_high</span>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
          <div class="form-check d-flex flex-row align-items-center nft-name nft-card-title select-all-btn"
            *ngIf="false">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
              (click)="$event.stopPropagation(); selectAllNfts()" />
            <p class="mb-0">Select All</p>
          </div>
          <!-- HIDE THIS WHEN FETCHING NFTs -->
          <ng-container *ngIf="!loadingNFTs; else loadingNFT">
            <div class="nft-list" *ngIf="myNfts.length; else nftEmptyState">
              <app-prize-card *ngFor="let nft of myNfts" [gameCard]="nft"
                (onAction)="onCardAction($event, nft)"></app-prize-card>
            </div>
            <div class="withdraw-section d-flex flex-column align-items-center gap-sm-3 gap-3"
              *ngIf="selectedNfts.length">
              <span class="withdrawn-section-hint">{{"compatible_chain_withdrawal" | translate: {chain:selectedChain}
                }}</span>
              <button class="yellow-gradient-btn primary-btn" translate (click)="withdrawNFTs()">
                withdraw_selected
              </button>
            </div>
            <!-- EMPTY STATE FOR MY NFT SECTION -->
            <ng-template #nftEmptyState>
              <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-sm-4">
                <img src="assets/images/no_nfts.png" alt="nft-card" class="no-nft-state" />
                <div class="error-msg d-flex flex-column align-items-center justify-content-center">
                  <h3 class="text-center title-text" translate>no_NFT_won</h3>
                  <span class="text-center title-text" translate>play_lootboxes</span><button
                    class="go-to-lootbox btn primary-btn mt-4" (click)="isPlayTabActive = true" translate>
                    lootboxes
                  </button>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #loadingNFT>
            <div class="loader-state d-flex flex-column align-items-center justify-content-center gap-sm-4">
              <app-loader [isLoading]="loadingNFTs" class="d-flex flex-row justify-content-center w-100"
                [loaderConfig]="{ height: 64, thickness: 4, isDarkBg:true }"></app-loader>
            </div>
          </ng-template>
        </div>
      </tab>
    </tabset>
  </div>
</div>